<template>
  <OrderPlanFailed :title="$t('paymentFailedTitle')">
    {{ $t('paymentFailed') }}
  </OrderPlanFailed>
</template>

<script>
import OrderPlanFailed from '@/components/Payment/Order/Plan/OrderPlanFailed';

export default {
  name: 'OrderFailed',
  components: { OrderPlanFailed },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
paymentFailed: Нам не удалось произвести списание с карты. Попробуйте выбрать другой способ оплаты.
paymentFailedTitle: Платёж не прошел
</i18n>
<i18n lang="yml" locale="en">
paymentFailed: We were unable to charge the card. Try another payment method.
paymentFailedTitle: Payment has failed
</i18n>
